import type { FactionId } from "./factions.js";
import type { FactionSectorId } from "./world-layout.js";

/** Display/progression order, independent of the persisted contract-board order. */
export const FACTION_ROUTES: Readonly<Record<FactionId, readonly FactionSectorId[]>> = {
  concord: ["concord-harmony", "concord-aegis", "concord-beacons", "concord-kepler", "concord-azure"],
  helion: ["helion-rift", "helion-imperative", "helion-forge", "helion-slag", "helion-iron"],
  nomads: ["nomads-last-chance", "nomads-shards", "nomads-mist", "nomads-graveyard", "nomads-magpie"],
};
export const HOME_SECTORS: Readonly<Record<FactionId, FactionSectorId>> = {
  concord: "concord-harmony", helion: "helion-rift", nomads: "nomads-last-chance",
};
export function isHomeSector(id: string): boolean {
  return Object.values(HOME_SECTORS).some((home) => home === id);
}
export function factionRegionNumber(id: string): number | null {
  for (const route of Object.values(FACTION_ROUTES)) {
    const index = route.findIndex((region) => region === id);
    if (index >= 0) return index + 1;
  }
  return null;
}
